import { Model } from 'modules/core/lib/mobx-rest'

export interface IIdentifierType {
  slug: string
  label: string
}

class IdentifierType extends Model<IIdentifierType> {
  static urlRoot() {
    return '/identifier_types'
  }

  get primaryKey(): string {
    return 'slug'
  }
}

export default IdentifierType
